import { makeLabels } from 'utils/i18n';

const NAMESPACE = 'page.merchant.sections.kyb.components.modal.formControls';

export const LABELS = makeLabels(
  {
    TITAN_DATA_BUTTON: ['titanDataButton', 'Insert Titan Data'],
    SAVED: ['saved', 'Saved'],
    CLEAR: ['clear', 'Clear'],
    LOADING: ['loading', 'Loading...'],
  },
  NAMESPACE,
);

export default LABELS;
